export default function Footer({ theme = 'light' }) {
  const bgClass = theme === 'light' ? 'bg-gray-100' : 'bg-gray-900';
  const textClass = theme === 'light' ? 'text-gray-700' : 'text-gray-400';

  return (
    <footer className={`${bgClass} w-full py-6 text-center`}>
      <p className={`text-sm ${textClass}`}>© 2025 Spaghetti Code Jungle.</p>
    </footer>
  );
}
